import type { TFunction } from 'i18next';
import { Breeder } from 'shared/@types';

function getBreederProfileSeoTitle(breeder: Breeder, t: TFunction<'screens'>) {
  const breeds = (breeder.breeds ?? []).map((breed) => breed.name).join(', ');

  if (!breeds) {
    return t('breeders.show_breeder.seo_title', {
      name: breeder.name,
    });
  }

  return t('breeders.show_breeder.seo_title_breeder_of', {
    name: breeder.name,
    breeds,
  });
}

export { getBreederProfileSeoTitle };
